import { signInWithRedirect } from '@aws-amplify/auth';
import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';

/** Managed login is the only sign-in path; the pool enforces domain join and password rules server-side. */
const SignIn = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSignIn = async () => {
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      await signInWithRedirect();
    } catch (error) {
      setErrorMessage(error.message || 'Sign-in failed. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100vw',
        width: '100vw',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          width: '100vw',
          height: '70px',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '24px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          margin: 0,
        }}
      >
        <img
          src='/factor_mind_logo.png'
          alt='Factor Mind'
          style={{ width: '200px', height: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          padding: '24px',
          margin: 0,
        }}
      >
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '32px',
            borderRadius: '8px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Typography variant='h5' gutterBottom>
            Sign in to Factor Mind
          </Typography>
          <Typography variant='body1' color='textSecondary' sx={{ mb: 3 }}>
            Use your DMRE account to continue.
          </Typography>
          <Button
            variant='contained'
            color='primary'
            fullWidth
            onClick={handleSignIn}
            disabled={isSubmitting}
          >
            Sign in
          </Button>
          {errorMessage && (
            <Typography color='error' sx={{ mt: 2 }}>
              {errorMessage}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SignIn;
